import { useContext } from "react";
import GlobalContext from "contexts/GlobalContext";
import surveyAdapter from "common/Adapters/SurveyAdapter/Router";

export function useSurvey() {
  const { language: lang } = useContext(GlobalContext);

  /**
   * Fetches a survey and updates the state with the result.
   */
  async function getSurvey(setSurvey) {
    const survey = await surveyAdapter.fetchSurvey(lang);
    if (survey) {
      sessionStorage.setItem("sia.benchmarking.surveyId", survey.id);
      setSurvey(survey);
    }
  }

  return {
    getSurvey,
  };
}
